export default __webpack_public_path__ + "static/media/border-plus.21aa9f7d.svg";